module.exports = {
  MOVE_RECEIVED: 'MOVE_RECEIVED',
  CASTLE_RECEIVED: 'CASTLE_RECEIVED',
  EN_PASSANT_RECEIVED: 'EN_PASSANT_RECEIVED',
  CHECKMATE_RECEIVED: 'CHECKMATE_RECEIVED'
};



/** WEBPACK FOOTER **
 ** ./constants/move_constants.js
 **/